import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { CartBrowsingCriteria } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { updateLastBC } from 'api/operations/cartServiceV2';
import { action, makeObservable, observable, override, runInAction, toJS } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';

export interface EditExpectedGroupSizeModalContext {
  getCartId: () => string;
  getBrowsingCriteria: () => CartBrowsingCriteria;
  refreshCart: (cartId: string) => Promise<void>;
}

interface Fields extends DefaultFormFields {
  groupSize: FormControl<string>;
}

export class EditExpectedGroupSizeModalStore extends ModalDelegate {
  private readonly _contextualData: EditExpectedGroupSizeModalContext;

  public readonly form = new FormController<Fields>(
    {
      groupSize: new FormControl('', {
        optional: false,
        trim: true,
        validations: ['containsOnlyNumbers'],
        customValidations: [{ check: (value: string): boolean => Number(value) > 0, msg: 'Cannot be less than 1' }],
      }),
    },
    {
      onSubmit: this._saveGroupSize.bind(this),
    },
  );

  private async _saveGroupSize(): Promise<void> {
    const { cartId, browsingCriteria } = runInAction(() => ({
      cartId: this._contextualData.getCartId(),
      browsingCriteria: {
        ...toJS(this._contextualData.getBrowsingCriteria()),
        groupSize: this.form.fields.groupSize.value,
      },
    }));

    await updateLastBC(cartId, browsingCriteria);
    await this._contextualData.refreshCart(cartId);
    runInAction(() => {
      this.close();
    });
  }

  public open(): void {
    this.form.fields.groupSize.value = this._contextualData.getBrowsingCriteria().groupSize || '';
    super.open();
  }

  public onClose(): void {
    this.close();
  }

  constructor(props: EditExpectedGroupSizeModalContext) {
    super();
    this._contextualData = props;

    makeObservable<EditExpectedGroupSizeModalStore, '_saveGroupSize'>(this, {
      _saveGroupSize: action.bound,
      form: observable,
      open: override,
      onClose: action.bound,
    });
  }
}
